import React from "react"; 
import Axios from 'axios'
import Cartela from '../_Components/Cartela'
import { Link } from 'react-router-dom';

export class AcompanharCartelas extends React.Component {
    constructor(props) {
super(props);
        this.state = {
            pedidos: [],
            cartelas: [],
            pedidosComErro: [],
            transacaoCorrente: null,
            cambistas: []
        };
        // this.getTodosCambistas()
        // this.getTodosPedidos()
        // this.desativarGabaritos()
        // this.restaurarGabaritos()
        // this.listarRecebidosComErro()
        // this.updateComissao()
        // this.recuperarVendaDireta()
    }

    corrigirTodasComissoes(){
      this.state.cambistas.forEach(cambista => {
        if(cambista.comissao == 20){
          cambista.comissao = 25
          this.atualizarUsuaro(cambista)
        }

      })
    }

    async atualizarUsuaro(usuario){
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("usuarios/atualizar-cliente", {id: usuario._id, ...usuario});
        console.log('ok')
      } catch (err) {
        console.log(err);
      }
    }

    async getTodosCambistas() {
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("usuarios/listar-todos-cambistas", {});
        this.setState({cambistas : response.data})
        this.corrigirTodasComissoes()
      } catch (err) {
        console.log(err);
      }
    }

    async updateComissao(){
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("usuarios/update-comissao", {});
      } catch (err) {
        console.log(err);
      }
    }

    async recuperarVendaDireta(){
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("transacoes/recuperar-venda-direta");
      } catch (err) {
        console.log(err);
      }
    }

    async listarRecebidosComErro(){
      try {
          var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
          });
          const response = await axiosInstance.post("pedidos/validados-com-erro", {});
          this.setState({pedidosComErro : response.data.filter(pedido => pedido.transacaoId == null) })
          console.log(response.data.filter(pedido => pedido.transacaoId == null))
          // this.corrigirRecebidosComErro()
        } catch (err) {
          console.log(err);
        }
  }


  async corrigirRecebidosComErro() {

    this.state.pedidosComErro.map(pedido => {
      this.criarTransacao(pedido)
    })

  }
  async criarTransacao(pedido) {
    try {
        var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem('apiUrl')
        })
        const response = await axiosInstance.post('transacoes/criar-transacao', {
            data: new Date(),
            documento: 'Documento Avulso',
            valor: pedido.cartelas.length * pedido.cartelas[0].valor,
            emissorId: pedido.clienteId,
            receptorId: pedido.cambistaId._id,
            tipo: 'Venda',
            observacao: pedido.codigo,
            status: true,
            natureza: 'ENTRADA',
            taxaComissao: ((pedido.cartelas.length * pedido.cartelas[0].valor) / 100) * pedido.cambistaId.comissao
        })
        if(response.data){
        this.state.transacaoCorrente = response.data
        this.setState({ transacaoCorrente: response.data })
        this.efetuarRecebimento(pedido, response.data)
        }
    } catch (err) {
        console.log(err)
    }
}

async efetuarRecebimento(pedido,transacao) {
  console.log(pedido)
  try {
      var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.post('pedidos/anexar-transacao', {
          id: pedido._id,
          transacaoId: transacao._id
      })
      console.log(response.data)
  } catch (err) {
      console.log(err)
  }
}
        
    async testeApi(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: 'https://api.iugu.com/v1/invoices?api_token=c858361767f70861f7157d89c4d7e23d'
            });
            const response = await axiosInstance.post("/",

                {
                    "ensure_workday_due_date": true,
                    "items": [
                      {
                        "description": "cartelas",
                        "quantity": 1,
                        "price_cents": 500
                      }
                    ],
                    "payer": {
                      "address": {
                        "zip_code": "64019-390",
                        "street": "murilo braga",
                        "number": "350",
                        "district": "sao pedro",
                        "city": "teresina",
                        "state": "PI",
                        "country": "Brasil"
                      },
                      "cpf_cnpj": "04493234393",
                      "name": "werbeson quadros"
                    },
                    "email": "besonquadros@gmail.com",
                    "due_date": "2020-08-16"
                  }

            );
            console.log(response)
          } catch (err) {
            console.log(err);
          }
    }


    async restauraSorteio(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("pedidos/restaura-sorteio");
          } catch (err) {
            console.log(err);
          }
    }

    async restaurarGabaritos(){
      try {
          var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
          });
          const response = await axiosInstance.post("gabaritos/restaurar-gabaritos");
          console.log(response.data)
        } catch (err) {
          console.log(err);
        }
  }

    async desativarGabaritos(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/desativar-gabaritos");
          } catch (err) {
            console.log(err);
          }
    }

    async getTodosPedidos(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("pedidos/listar-2", {});
            this.setState({pedidos: response.data});
            if(response.data){
                this.getTodasCartelas()
            }
          } catch (err) {
            console.log(err);
          }
    }



    async getTodasCartelas(){
        var zeroCartelas = []
        this.state.pedidos.map(pedido =>{
            pedido.cartelas.map(cartela => {
                if(cartela.codigo[6] == '0'){
                    zeroCartelas.push(cartela)
                }
            })
        })
        this.setState({cartelas : zeroCartelas})
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    {this.state.cartelas.map(cartela => {
                        return <Cartela conferir={"Linha"} cartela={cartela}></Cartela>
                    })}
                </div>
            </div>
        );
    }


}






export default AcompanharCartelas;
